import React, { useState } from 'react';
import { Button } from '../button/button';
import { ButtonIntent, ButtonTier } from '../button/button.types';
import styles from './table-actions-bar.module.css';
import { ITableActionsBarProps } from './table-actions-bar.types';
import { CardContent } from '../card/card';

export const TableActionsBar = ({
  onAction,
  bulkActions,
  singularActions,
  showBulkActions = true,
}: ITableActionsBarProps) => {
  const handleClick = (action: string) => {
    onAction?.(action);
  };
  const [batchAction, setBatchAction] = useState<string>(
    bulkActions?.[0].value ?? ''
  );

  return (
    <CardContent className={`${styles.tableActionsBar}`}>
      <div className={styles.bulkActions}>
        {(bulkActions ?? []).length > 0 && showBulkActions && (
          <>
            <select
              onChange={(e) => {
                setBatchAction(e.target.value);
              }}
            >
              {bulkActions?.map((action) => (
                <option value={action.value} key={action.value}>
                  {action.display}
                </option>
              ))}
            </select>
            <Button
              onClick={() => {
                bulkActions?.find((a) => a.value === batchAction)?.action?.();
                handleClick(batchAction);
              }}
              intent={ButtonIntent.Positive}
              tier={ButtonTier.Secondary}
            >
              Go
            </Button>
          </>
        )}
      </div>

      {(singularActions ?? []).length && (
        <div className={styles.singularActions}>
          {singularActions?.map((action) => (
            <Button
              key={action.value}
              onClick={() => {
                action.action?.();
                handleClick(action.value);
              }}
              intent={ButtonIntent.Positive}
              tier={ButtonTier.Secondary}
            >
              {action.display}
            </Button>
          ))}
        </div>
      )}
    </CardContent>
  );
};
